/**
 * @param roiCalculatorDocument {Document}
 * @return {boolean}
 */
module.exports = function isDownloadPdfButtonInsideRoiCalculator(roiCalculatorDocument) {
    return roiCalculatorDocument.querySelectorAll('#open-report').length > 0;
}
